import React, { Component } from 'react'
import ReactPaginate from 'react-paginate'
import { stores, view } from '../../stores'
import { Loader } from '../ui/states/Loader'
import { InvoiceItem } from './InvoiceItem'

class InvoiceListComponent extends Component {
  async componentDidMount () {
    await stores.account.getPayments()
  }

  render () {
    return (
      <div className='layout__container'>
        {
          !stores.account.payments.loading && stores.account.payments.content !== undefined
          ? stores.account.payments.content.map((facture, i) => <InvoiceItem key={facture.id + i} facture={facture} />)
          : <Loader size='small' />
        }
        {
          !stores.account.payments.loading
          ? <ReactPaginate previousLabel={'< Précédent'}
            nextLabel={'Suivant >'}
            breakLabel={<a href=''>...</a>}
            breakClassName={'break-me'}
            pageCount={stores.account.payments.totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={(data) => stores.account.getPayments({ page: data.selected })}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'} />
          : ''
        }
      </div>)
  }
}

export const InvoiceList = view(InvoiceListComponent)



// WEBPACK FOOTER //
// ./src/components/customer/InvoiceList.js